import { render } from "./Assigns.vue?vue&type=template&id=68675ece&scoped=true"
import script from "./Assigns.vue?vue&type=script&lang=js"
export * from "./Assigns.vue?vue&type=script&lang=js"

import "./Assigns.vue?vue&type=style&index=0&id=68675ece&lang=css"
import "./Assigns.vue?vue&type=style&index=1&id=68675ece&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68675ece"]])

export default __exports__